/**
 * Single source of truth for Indian states/UTs and cities per state.
 * Used for State/City dependent dropdowns (e.g. Company Management).
 */

const STATE_NAMES = [
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chhattisgarh",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttar Pradesh",
  "Uttarakhand",
  "West Bengal",
  "Andaman and Nicobar Islands",
  "Chandigarh",
  "Dadra and Nagar Haveli and Daman and Diu",
  "Jammu and Kashmir",
  "Ladakh",
  "Lakshadweep",
  "Delhi",
  "Puducherry",
];

/** @type {{ value: string, label: string }[]} */
export const INDIA_STATES = STATE_NAMES.map((s) => ({ value: s, label: s }));

/** @type {Record<string, { value: string, label: string }[]>} */
export const INDIA_CITIES_BY_STATE = {
  "Andhra Pradesh": [
    "Visakhapatnam", "Vijayawada", "Guntur", "Nellore", "Kurnool", "Rajahmundry", "Kakinada", "Kadapa", "Tirupati", "Anantapur", "Vizianagaram", "Eluru", "Ongole", "Nandyal", "Machilipatnam",
  ].map((c) => ({ value: c, label: c })),
  "Arunachal Pradesh": [
    "Itanagar", "Naharlagun", "Pasighat", "Namsai", "Changlang", "Tezu", "Ziro", "Bomdila", "Tawang", "Seppa",
  ].map((c) => ({ value: c, label: c })),
  Assam: [
    "Guwahati", "Silchar", "Dibrugarh", "Jorhat", "Nagaon", "Tinsukia", "Tezpur", "Bongaigaon", "Dhubri", "Diphu", "North Lakhimpur", "Karimganj", "Goalpara", "Sivasagar", "Golaghat",
  ].map((c) => ({ value: c, label: c })),
  Bihar: [
    "Patna", "Gaya", "Bhagalpur", "Muzaffarpur", "Darbhanga", "Purnia", "Bihar Sharif", "Arrah", "Begusarai", "Katihar", "Munger", "Chhapra", "Saharsa", "Hajipur", "Dehri",
  ].map((c) => ({ value: c, label: c })),
  Chhattisgarh: [
    "Raipur", "Bhilai", "Bilaspur", "Korba", "Durg", "Rajnandgaon", "Raigarh", "Jagdalpur", "Ambikapur", "Dhamtari",
  ].map((c) => ({ value: c, label: c })),
  Goa: [
    "Panaji", "Margao", "Vasco da Gama", "Mapusa", "Ponda", "Bicholim", "Curchorem", "Sanquelim", "Quepem", "Cuncolim",
  ].map((c) => ({ value: c, label: c })),
  Gujarat: [
    "Ahmedabad", "Surat", "Vadodara", "Rajkot", "Bhavnagar", "Jamnagar", "Junagadh", "Gandhinagar", "Anand", "Nadiad", "Morbi", "Mehsana", "Bhuj", "Porbandar", "Palanpur",
  ].map((c) => ({ value: c, label: c })),
  Haryana: [
    "Faridabad", "Gurgaon", "Panipat", "Ambala", "Yamunanagar", "Rohtak", "Hisar", "Karnal", "Sonipat", "Panchkula", "Bhiwani", "Sirsa", "Bahadurgarh", "Jind", "Thanesar",
  ].map((c) => ({ value: c, label: c })),
  "Himachal Pradesh": [
    "Shimla", "Dharamshala", "Solan", "Mandi", "Palampur", "Baddi", "Nahan", "Kullu", "Chamba", "Una", "Hamirpur", "Bilaspur", "Kangra", "Sirmaur",
  ].map((c) => ({ value: c, label: c })),
  Jharkhand: [
    "Ranchi", "Jamshedpur", "Dhanbad", "Bokaro", "Deoghar", "Hazaribagh", "Giridih", "Ramgarh", "Phusro", "Medininagar", "Chaibasa", "Dumka", "Gumla", "Pakur",
  ].map((c) => ({ value: c, label: c })),
  Karnataka: [
    "Bengaluru", "Mysuru", "Hubballi", "Mangaluru", "Belagavi", "Kalaburagi", "Davanagere", "Ballari", "Vijayapura", "Shivamogga", "Tumakuru", "Raichur", "Bidar", "Hospet", "Gadag",
  ].map((c) => ({ value: c, label: c })),
  Kerala: [
    "Thiruvananthapuram", "Kochi", "Kozhikode", "Thrissur", "Kollam", "Alappuzha", "Palakkad", "Malappuram", "Kannur", "Kasaragod", "Kottayam", "Pathanamthitta", "Idukki", "Ernakulam",
  ].map((c) => ({ value: c, label: c })),
  "Madhya Pradesh": [
    "Bhopal", "Indore", "Jabalpur", "Gwalior", "Ujjain", "Sagar", "Dewas", "Satna", "Ratlam", "Rewa", "Murwara", "Singrauli", "Burhanpur", "Khandwa", "Morena",
  ].map((c) => ({ value: c, label: c })),
  Maharashtra: [
    "Mumbai", "Pune", "Nagpur", "Thane", "Nashik", "Aurangabad", "Solapur", "Kolhapur", "Amravati", "Navi Mumbai", "Sangli", "Malegaon", "Jalgaon", "Akola", "Latur", "Ahmednagar", "Dhule", "Ichalkaranji", "Chandrapur", "Parbhani", "Jalna", "Bhusawal", "Panvel", "Ulhasnagar", "Nanded", "Mira-Bhayandar", "Bid", "Gondia", "Yavatmal", "Barshi",
  ].map((c) => ({ value: c, label: c })),
  Manipur: [
    "Imphal", "Thoubal", "Bishnupur", "Churachandpur", "Kakching", "Ukhrul", "Senapati", "Tamenglong", "Jiribam", "Moreh",
  ].map((c) => ({ value: c, label: c })),
  Meghalaya: [
    "Shillong", "Tura", "Nongstoin", "Jowai", "Williamnagar", "Resubelpara", "Mawkyrwat", "Nongpoh", "Baghmara", "Ampati",
  ].map((c) => ({ value: c, label: c })),
  Mizoram: [
    "Aizawl", "Lunglei", "Saiha", "Champhai", "Kolasib", "Serchhip", "Mamit", "Khawzawl", "Saitual", "Hnahthial",
  ].map((c) => ({ value: c, label: c })),
  Nagaland: [
    "Kohima", "Dimapur", "Mokokchung", "Tuensang", "Wokha", "Zunheboto", "Phek", "Mon", "Kiphire", "Longleng",
  ].map((c) => ({ value: c, label: c })),
  Odisha: [
    "Bhubaneswar", "Cuttack", "Rourkela", "Berhampur", "Sambalpur", "Puri", "Balasore", "Bhadrak", "Baripada", "Jharsuguda", "Bargarh", "Jeypore", "Bhawanipatna", "Dhenkanal", "Barbil",
  ].map((c) => ({ value: c, label: c })),
  Punjab: [
    "Ludhiana", "Amritsar", "Jalandhar", "Patiala", "Bathinda", "Mohali", "Pathankot", "Hoshiarpur", "Batala", "Moga", "Malerkotla", "Khanna", "Phagwara", "Muktsar", "Barnala",
  ].map((c) => ({ value: c, label: c })),
  Rajasthan: [
    "Jaipur", "Jodhpur", "Udaipur", "Kota", "Bikaner", "Ajmer", "Bhilwara", "Alwar", "Bharatpur", "Sikar", "Pali", "Sri Ganganagar", "Tonk", "Kishangarh", "Hanumangarh",
  ].map((c) => ({ value: c, label: c })),
  Sikkim: [
    "Gangtok", "Namchi", "Gyalshing", "Mangan", "Ravangla", "Rangpo", "Jorethang", "Singtam", "Pelling", "Yuksom",
  ].map((c) => ({ value: c, label: c })),
  "Tamil Nadu": [
    "Chennai", "Coimbatore", "Madurai", "Tiruchirappalli", "Salem", "Tirunelveli", "Tiruppur", "Ranipet", "Nagercoil", "Thanjavur", "Vellore", "Kancheepuram", "Erode", "Tiruvannamalai", "Dindigul",
  ].map((c) => ({ value: c, label: c })),
  Telangana: [
    "Hyderabad", "Warangal", "Nizamabad", "Karimnagar", "Ramagundam", "Khammam", "Mahbubnagar", "Nalgonda", "Adilabad", "Suryapet", "Siddipet", "Miryalaguda", "Sangareddy", "Vikarabad", "Mancherial",
  ].map((c) => ({ value: c, label: c })),
  Tripura: [
    "Agartala", "Udaipur", "Dharmanagar", "Kailasahar", "Ambassa", "Belonia", "Khowai", "Sabroom", "Bishalgarh", "Teliamura",
  ].map((c) => ({ value: c, label: c })),
  "Uttar Pradesh": [
    "Lucknow", "Kanpur", "Ghaziabad", "Agra", "Varanasi", "Meerut", "Allahabad", "Bareilly", "Aligarh", "Moradabad", "Saharanpur", "Gorakhpur", "Noida", "Firozabad", "Jhansi", "Muzaffarnagar", "Mathura", "Rampur", "Shahjahanpur", "Farrukhabad", "Mau", "Hapur", "Etawah", "Mirzapur", "Bulandshahr", "Sambhal", "Amroha", "Hardoi", "Fatehpur", "Raebareli", "Orai", "Sitapur", "Bahraich", "Modinagar", "Unnao", "Jaunpur", "Lakhimpur", "Hathras", "Budaun", "Faizabad", "Azamgarh", "Basti", "Chandausi", "Akbarpur", "Ballia", "Tanda", "Greater Noida",
  ].map((c) => ({ value: c, label: c })),
  Uttarakhand: [
    "Dehradun", "Haridwar", "Roorkee", "Haldwani", "Rudrapur", "Kashipur", "Rishikesh", "Pithoragarh", "Ramnagar", "Mussoorie", "Almora", "Kichha", "Tehri", "Pauri", "Nainital",
  ].map((c) => ({ value: c, label: c })),
  "West Bengal": [
    "Kolkata", "Howrah", "Durgapur", "Asansol", "Siliguri", "Bardhaman", "Malda", "Baharampur", "Habra", "Kharagpur", "Shantipur", "Dankuni", "Dhulian", "Ranaghat", "Haldia", "Raiganj", "Krishnanagar", "Nabadwip", "Medinipur", "Jalpaiguri", "Balurghat", "Basirhat", "Bankura", "Chakdaha", "Darjeeling",
  ].map((c) => ({ value: c, label: c })),
  "Andaman and Nicobar Islands": [
    "Port Blair", "Diglipur", "Rangat", "Mayabunder", "Car Nicobar", "Nancowry", "Little Andaman", "Hut Bay",
  ].map((c) => ({ value: c, label: c })),
  Chandigarh: [
    "Chandigarh", "Manimajra", "Sector 17", "Sector 22", "Sector 35", "Panchkula", "Mohali",
  ].map((c) => ({ value: c, label: c })),
  "Dadra and Nagar Haveli and Daman and Diu": [
    "Silvassa", "Daman", "Diu", "Naroli", "Rakholi", "Khanvel", "Amli", "Vapi",
  ].map((c) => ({ value: c, label: c })),
  "Jammu and Kashmir": [
    "Srinagar", "Jammu", "Anantnag", "Baramulla", "Sopore", "Kathua", "Udhampur", "Kupwara", "Budgam", "Leh", "Kargil", "Pulwama", "Ganderbal", "Bandipore", "Shopian",
  ].map((c) => ({ value: c, label: c })),
  Ladakh: [
    "Leh", "Kargil", "Nubra", "Zanskar", "Drass", "Diskit", "Padum", "Nyoma", "Chushul", "Turtuk",
  ].map((c) => ({ value: c, label: c })),
  Lakshadweep: [
    "Kavaratti", "Agatti", "Minicoy", "Amini", "Andrott", "Kadmat", "Kiltan", "Chetlat", "Bitra", "Kalpeni",
  ].map((c) => ({ value: c, label: c })),
  Delhi: [
    "New Delhi", "North Delhi", "South Delhi", "East Delhi", "West Delhi", "Central Delhi", "Dwarka", "Rohini", "Saket", "Karol Bagh", "Connaught Place", "Lajpat Nagar", "Hauz Khas", "Janakpuri", "Paharganj",
  ].map((c) => ({ value: c, label: c })),
  Puducherry: [
    "Puducherry", "Ozhukarai", "Karaikal", "Yanam", "Mahe", "Villianur", "Ariankuppam", "Kurumbapet", "Embalam", "Nettapakkam",
  ].map((c) => ({ value: c, label: c })),
};

/** Get cities for a state (empty array if state unknown). */
export function getCitiesForState(stateName) {
  if (!stateName || typeof stateName !== "string") return [];
  const trimmed = stateName.trim();
  return INDIA_CITIES_BY_STATE[trimmed] || [];
}

/** Check if a city belongs to the given state. */
export function isCityInState(cityName, stateName) {
  const cities = getCitiesForState(stateName);
  return cities.some((c) => (c.value || c).trim() === (cityName || "").trim());
}
